import subscription from './injectSubscription';

export default [
  ...subscription,
];
